<template>
<div class="chapter">
<div class="inner_page">
<div class="sgc-toc-title">
    Table of Contents
  </div>
<div class="sgc-toc-level-1">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_1" title="Link target outside of Sample">Cómo utilizar los diagramas del diapasón</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_2" title="Link target outside of Sample">Problemas técnicos para principiantes</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_3" title="Link target outside of Sample">Flexibilidad</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_4" title="Link target outside of Sample">Técnicas</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_5" title="Link target outside of Sample">Acordes</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_72" title="Link target outside of Sample">Acordes mayores</span>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_7" title="Link target outside of Sample">C mayor</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_8" title="Link target outside of Sample">A mayor</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_9" title="Link target outside of Sample">G mayor</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_10" title="Link target outside of Sample">E mayor</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_11" title="Link target outside of Sample">D mayor</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_12" title="Link target outside of Sample">Acordes menores</span>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_13" title="Link target outside of Sample">E menor</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_14" title="Link target outside of Sample">A menor</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_15" title="Link target outside of Sample">D menor</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_16" title="Link target outside of Sample">Acordes de 7ma dominante</span>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_17" title="Link target outside of Sample">A7</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_18" title="Link target outside of Sample">G7</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_19" title="Link target outside of Sample">E7</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_20" title="Link target outside of Sample">D7</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_21" title="Link target outside of Sample">Acordes de 7ma menor</span>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_22" title="Link target outside of Sample">Em7</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_23" title="Link target outside of Sample">Am7</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_24" title="Link target outside of Sample">Dm7</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_25" title="Link target outside of Sample">Acordes de 7ma mayor</span>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_26" title="Link target outside of Sample">Emaj7</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_27" title="Link target outside of Sample">Amaj7</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_28" title="Link target outside of Sample">Dmaj7</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_29" title="Link target outside of Sample">Cmaj7</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_30" title="Link target outside of Sample">Fmaj7</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_31" title="Link target outside of Sample">Acordes de 2da suspendida</span>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_32" title="Link target outside of Sample">Asus2</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_33" title="Link target outside of Sample">Dsus2</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_34" title="Link target outside of Sample">Fsus2</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_35" title="Link target outside of Sample">Gsus2</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_36" title="Link target outside of Sample">Acordes de 4ta suspendida</span>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_37" title="Link target outside of Sample">Asus4</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_38" title="Link target outside of Sample">Csus4</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_39" title="Link target outside of Sample">Dsus4</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_40" title="Link target outside of Sample">Esus4</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_41" title="Link target outside of Sample">Fsus4</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_42" title="Link target outside of Sample">Añadir 9 acordes</span>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_43" title="Link target outside of Sample">Cadd9</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_44" title="Link target outside of Sample">Eadd9</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_45" title="Link target outside of Sample">Fadd9</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_46" title="Link target outside of Sample">Acordes de potencia</span>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_6" title="Link target outside of Sample">Diagrama de notas del diapasón</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_73" title="Link target outside of Sample">Cejillas para principiantes</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_74" title="Link target outside of Sample">Otros acordes</span>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_75" title="Link target outside of Sample">G 6ta</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_47" title="Link target outside of Sample">A dominante 13na suspendida 4ta</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_51" title="Link target outside of Sample">D menor 7ma bemol 5</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_52" title="Link target outside of Sample">D aumentado</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_53" title="Link target outside of Sample">A disminuido</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_54" title="Link target outside of Sample">E disminuido</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_55" title="Link target outside of Sample">A menor 7ma bemol 5</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_56" title="Link target outside of Sample">E menor 7ma bemol 5</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_57" title="Link target outside of Sample">A dominante 11na</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_58" title="Link target outside of Sample">A menor 11na</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_59" title="Link target outside of Sample">C mayor 13na</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_60" title="Link target outside of Sample">E menor 13na</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_61" title="Link target outside of Sample">G menor 13na</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_62" title="Link target outside of Sample">C mayor 7ma sostenido 5</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_63" title="Link target outside of Sample">E dominante 7ma bemol 5</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_64" title="Link target outside of Sample">E dominante 7ma suspendida 4ta</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_65" title="Link target outside of Sample">D disminuido 7ma</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_66" title="Link target outside of Sample">D menor / mayor 7ma</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_67" title="Link target outside of Sample">D 6ta</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_68" title="Link target outside of Sample">E menor añadida 9na</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_69" title="Link target outside of Sample">C dominante 9na suspendida 4ta</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_70" title="Link target outside of Sample">Sugerencias de canciones con acordes fáciles</span>
<div class="sgc-toc-level-2">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_71" title="Link target outside of Sample">Consejos</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_77" title="Link target outside of Sample">Gracias por comprar este libro</span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TOC.vue?4cc38870